export default "__VITE_ASSET__BZgV5pWy__"